// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__379Vm","imageUploader":"EGiftCard_imageUploader__2XAM1"};